import React, {useState} from 'react';
import numberFormat from "../../../helpers/numberFormat";
import axios from "../../../helpers/axios";
import DropDownCategory from "./dropDownCategory";

const RenderStandartTablePart = ({table,fromGoogle,somthingWithCategory,categories}) => {
  const [show, setShow] = useState(false)
  return <>
    <tr style={{backgroundColor: "#e8f6e9"}}   className="category-header-row">
      <td className={'text-center'}>
        {!fromGoogle && renderFirstCol(table, somthingWithCategory, categories)}
      </td>
      <th colSpan={3} style={{paddingLeft: '1rem'}}>{table.name}</th>
      <th className={'text-end'}>{numberFormat(table.total)}</th>
      <th colSpan={2}>KZT</th>
      <th onClick={() => setShow(!show)} className={'pointer'}><i className={`fa fa-chevron-${show ? 'up' : 'down'} pointer`}></i>
      </th>
    </tr>
      {show && table.values.map((row, i) => renderRow(row, i))}
  </>
};


export default RenderStandartTablePart;

const renderRow = (row, i) => {
  return (
    <tr
      key={i}
    >
      <td style={{paddingLeft: '0.5rem'}}>{row.list}</td>
      <td>{row.issueDate}</td>
      <td>{row.counterparty.name}</td>
      <td>{row.type}</td>
      <td className={'text-end'}>{numberFormat(row.summ)}</td>
      <td className={'text-center'}>{row.currency}</td>
      <td>{row.comment}</td>
    </tr>
  )
}

const renderFirstCol = (table,somthingWithCategory,categories) =>{
  const removeItemFromCategory = (text,data) =>{
    if(window.confirm(text)){
      somthingWithCategory(data)
    }
  }
  if(table.categoryId) {
    return <i className={`fa fa-minus pointer`}
              onClick={()=>removeItemFromCategory(`Вы хотите удалить ${table.name} из категории?`,
                {id:table.categoryId,
                  child:table.name,
                  deletion: true})}></i>
  }
  return <DropDownCategory categories={categories} table={table} somthingWithCategory={somthingWithCategory}/>
}
